exports.connect = {
	url: "https://api.camping-hiriberria.camp/"
}
